import { apiClient } from './axios';

import type {
  FinanceApplicationQuery,
  FinanceApplicationWithRelations,
  PaginatedResponse,
} from '@repo/shared-types';

export const financeApplicationsApi = {
  getAll: async (query: Partial<FinanceApplicationQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<FinanceApplicationWithRelations>>(
      '/finance-applications',
      { params: query },
    );
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<FinanceApplicationWithRelations>(
      `/finance-applications/${id}`,
    );
    return response.data;
  },

  getByCall: async (callId: string) => {
    const response = await apiClient.get<FinanceApplicationWithRelations[]>(
      `/finance-applications/by-call/${callId}`,
    );
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/finance-applications/${id}`);
  },
};
